import React from 'react';

import { Link } from 'react-router-dom';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { GetItemStockInheritanceDTO } from '@recurrency/core-api-schema/dist/items/getItemStockInheritance';
import { Alert, Tooltip } from 'antd';
import { theme } from 'theme';

import { makePath, routePaths } from 'utils/routes';

export const StockInheritanceDescendantBanner = ({
  validDescendants,
}: {
  validDescendants: GetItemStockInheritanceDTO[];
}) =>
  validDescendants.length > 0 ? (
    <Tooltip title="Recurrency includes stock from replaced items directly in this item's net stock. Replaced items are zeroed out in planning to avoid over-ordering.">
      <Alert
        icon={<ExclamationCircleOutlined />}
        message={
          <>
            This item's stock is inherited by{' '}
            {validDescendants.map((item: GetItemStockInheritanceDTO, index: number) => (
              <React.Fragment key={item.itemCode}>
                <Link to={makePath(routePaths.purchasing.itemDetails, { id: item.itemCode })}>{item.itemCode}</Link>
                {index < validDescendants.length - 1 ? ', ' : ''}
              </React.Fragment>
            ))}
            .
          </>
        }
        banner
        className={css`
          background-color: ${theme.colors.primary[200]};
          border-radius: 10px;
          .ant-alert-icon {
            color: ${theme.colors.neutral[900]};
          }
          .ant-alert-message {
            color: ${theme.colors.neutral[900]};
          }
        `}
      />
    </Tooltip>
  ) : null;
